import React, { useState } from 'react';
import { Modal, Button, Input, DatePicker, Row, Col, message } from 'antd';
import { CloseOutlined, CheckOutlined, FileTextOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { startCargaPagoMasivo } from '../../../../context/actions/pagos2Actions';

export default function ModalCargaMasivaXLSX({ visible, onClose, onSuccess }) {
  const dispatch = useDispatch();
  const [fecha, setFecha] = useState(null);
  const [ordenesPago, setOrdenesPago] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setFecha(null);
    setOrdenesPago('');
    setLoading(false);
    onClose();
  };

  const handleSubmit = async () => {
    const ordenes = ordenesPago
      .split('\n')
      .map(op => op.trim())
      .filter(op => op)
      .map(op => parseInt(op, 10))
      .filter(op => !isNaN(op));

    if (ordenes.length === 0) {
      message.warning('Debes ingresar al menos una orden de pago válida');
      return;
    }

    const payload = {
      fecha: fecha.format('YYYY-MM-DD'),
      ordenesPagoID: ordenes
    };

    setLoading(true);

    try {
      const result = await dispatch(startCargaPagoMasivo(payload));

      if (result && result.success) {
        if (onSuccess) {
          onSuccess();
        }
        handleClose();
      }
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = () => {
    return !fecha || !ordenesPago.trim() || loading;
  };

  return (
    <Modal
      title={
        <>
          <FileTextOutlined style={{ marginRight: 8 }} />
          Carga Masiva de Órdenes de Pago
        </>
      }
      open={visible}
      onCancel={handleClose}
      wrapClassName="pagos-v2-modal"
      width={700}
      footer={[
        <Button key="close" onClick={handleClose} disabled={loading} icon={<CloseOutlined />}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          disabled={isDisabled()}
          loading={loading}
          icon={<CheckOutlined />}
        >
          Procesar Órdenes
        </Button>
      ]}
    >
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontWeight: 500 }}>Fecha</label>
          </div>
          <DatePicker
            value={fecha}
            onChange={setFecha}
            style={{ width: '100%' }}
            placeholder="Selecciona una fecha"
            format="DD/MM/YYYY"
            disabled={loading}
          />
        </Col>
        <Col span={24} style={{ marginTop: 10 }}>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontWeight: 500 }}>Órdenes de Pago</label>
          </div>
          <Input.TextArea
            placeholder="Ingresa las órdenes de pago, una por línea...&#10;Ejemplo:&#10;123&#10;456&#10;789"
            value={ordenesPago}
            onChange={(e) => setOrdenesPago(e.target.value)}
            style={{ height: 400 }}
            disabled={loading}
          />
        </Col>
      </Row>
    </Modal>
  );
}
